import '../../src/js/components/pagination';
import '../../src/js/components/filter-selections';
import { strlFacetwpCheckboxAriaLabels } from '../../src/js/components/a11y';

const filterTitles = document.querySelectorAll('.filter-title');
filterTitles.forEach((filterTitle) => {
	filterTitle.addEventListener('click', (e) => {
		const controlsId = filterTitle.getAttribute('aria-controls');
		const controlledElement = document.getElementById(controlsId);
		const isExpanded = filterTitle.getAttribute('aria-expanded') === 'true';

		filterTitle.setAttribute('aria-expanded', !isExpanded);
		e.target.parentNode.classList.toggle('open');

		if (controlledElement) {
			controlledElement.classList.toggle('hidden');
		}
	});
});

document.addEventListener('facetwp-loaded', () => {
	FWP.hooks.addAction(
		'facetwp/loaded',
		function () {
			strlFacetwpCheckboxAriaLabels();
		},
		999
	);
});
